module.exports = __webpack_public_path__ + "media/images/icons/energie-icons-leuchtturm-circle-98a7a7b85b3094736674beeeb7b07573.svg";